import { Collection } from "../../Collection/types/collection";

export type Mod = {
	id: string;
	state: ModState;
	title: string;
	updateDate?: Date;
	workshopUpdateDate: Date;
	postedDate: Date;
	reportedSize: number;
	downloadProgress?: number;
	sizeOnDisk?: number;
	isSigned?: boolean;
	image: string;
	tags?: string[];
	scope?: ModScope;
	collections?: Collection[];
};

export const ModState = {
	Downloaded: 'Downloaded',
	Downloading: 'Downloading',
	Workshop: 'Workshop',
	Selected: 'Selected',
	Collection: 'Collection',
} as const;
export type ModState = typeof ModState[keyof typeof ModState];

export const ModScope = {
	Required: 'Required',
	Optional: 'Optional',
	Server: 'Server',
} as const;
export type ModScope = typeof ModScope[keyof typeof ModScope];